<script lang="ts">
	import Checkbox from "./Checkbox.svelte";

	let formControlClass = "";
	export { formControlClass as class };
	export let gdprApprovedAt: string | null = null;

	let input: HTMLInputElement | null = null;

	$: {
		if (input) {
			input.checked = Boolean(gdprApprovedAt);
		}
	}

	function checkedTerms(event: Event): void {
		const input = event.target as HTMLInputElement;
		gdprApprovedAt = input.checked ? new Date().toISOString() : null;
	}
</script>

<div class="relative">
	<Checkbox bind:input id="gdprApproved" name="" on:change={checkedTerms} required class={formControlClass}>
		Souhlasím se&nbsp;<a
			class="text-black-400 hover:text-black-700 decoration-primary-400 underline transition-[color,text-decoration] duration-500 ease-in-out hover:decoration-transparent"
			href="/documents/SladkáDílnaZásadyZpracováníOsobníchÚdajů.pdf"
			target="_blank"
		>
			Zásadami zpracování osobních údajů
		</a>
	</Checkbox>
	<input type="hidden" name="gdprApprovedAt" value={gdprApprovedAt ?? ""} />
</div>
